module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/railSprite.efeb7ad7.png";